module.exports = __webpack_public_path__ + "static/img/bg18.9c0cdf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg18.jpg
// module id = shsL
// module chunks = 1